// ageBuckets.js

export const YOUTH_BUCKETS = [
  { label: "3–4", min: 3, max: 4 },
  { label: "5–6", min: 5, max: 6 },
  { label: "7–8", min: 7, max: 8 },
  { label: "9–10", min: 9, max: 10 },
  { label: "11–12", min: 11, max: 12 },
  { label: "13–14", min: 13, max: 14 },
  { label: "15–17", min: 15, max: 17 },
];

export const ADULT_BUCKETS = [
  { label: "18+", min: 18, max: 120 },
  { label: "21+", min: 21, max: 120 },
  { label: "30+", min: 30, max: 120 },
  { label: "35+", min: 35, max: 120 },
  { label: "40+", min: 40, max: 120 },
  { label: "45+", min: 45, max: 120 },
  { label: "50+", min: 50, max: 120 },
  { label: "60+", min: 60, max: 120},
];